// reducers/connect/token.js

export function connectTokenHasErrored(state = false, action) {
  switch (action.type) {
    case 'CONNECT_TOKEN_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function connectTokenIsLoading(state = true, action) {
  switch (action.type) {
    case 'CONNECT_TOKEN_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function connectToken(state = {}, action) {
  switch(action.type) {
    case 'CONNECT_TOKEN_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}